import { Static, Type } from '@sinclair/typebox'
import { EmailType, PasswordType } from '../../user/user'

export const SignInRequest = Type.Object({
    email: EmailType,
    password: PasswordType,
})

export type SignInRequest = Static<typeof SignInRequest>

export const SignInWithGoogleRequest = Type.Object({
    code: Type.String(),
})
export type SignInWithGoogleRequest = Static<typeof SignInWithGoogleRequest>

export const SignInWithKizeoRequest = Type.Object({
    code: Type.String(),
})
export type SignInWithKizeoRequest = Static<typeof SignInWithKizeoRequest>
